import type { BrokerageHolding } from "../types";

export function holdingsBenchmarkInput(holdings: BrokerageHolding[]) {
  const positions = new Map<string, number>();
  let cash = 0;
  let unpriced = 0;
  let invalid = false;
  for (const holding of holdings) {
    const value = holding.value;
    if (value == null || !Number.isFinite(value) || value < 0 || (holding.quantity ?? 0) < 0) {
      invalid = true;
      continue;
    }
    if (value === 0) continue;
    const symbol = holding.symbol?.trim().toUpperCase();
    if (holding.currency && holding.currency.toUpperCase() !== "USD") {
      // Different currency values cannot be summed without FX conversion.
      invalid = true;
    } else if (holding.security_type === "cash") {
      cash += value;
    } else if (symbol && /^[A-Z0-9.-]{1,10}$/.test(symbol)) {
      positions.set(symbol, (positions.get(symbol) ?? 0) + value);
    } else {
      unpriced += value;
    }
  }
  return {
    positions: [...positions].map(([symbol, weight]) => ({ symbol, weight })),
    cash_weight: cash, unpriced_weight: unpriced, invalid,
  };
}
